import "../../style.css";
import React, { useState, useMemo } from "react";
import EditableField from "../../components/EditableField";
import { BsArrowDownUp } from "react-icons/bs";
import DetailModal from "../../components/Common/DetailModal";
import formatDateString from "../../components/utils/DateFormate";
// import { Link } from "react-router-dom";

const FetchTable = ({
  currentPosts,
  handleCheckboxChange,
  setFilterData,
  setData,
  filterData,
  selectedIds,
  selectAll,
  handleSelectAll,
  selectId,
}) => {
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [idDetails, setIdDetails] = useState([]);
  const [showIdModal, setShowIdModal] = useState(false);
  const [idLoading, setIdLoading] = useState(false);

  const handleEdit = (id, field, value) => {
    const updatedData = filterData.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value,
        };
      }
      return item;
    });
    setData(updatedData);
    setFilterData(updatedData);
  };

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection((prevSortDirection) =>
        prevSortDirection === "asc" ? "desc" : "asc",
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    const sortedArray = [...currentPosts];

    if (sortColumn !== "") {
      sortedArray.sort((a, b) => {
        const valueA = a[sortColumn];
        const valueB = b[sortColumn];

        if (sortColumn === "lastmodified") {
          // Convert timestamps to Date objects for comparison
          const dateA = new Date(valueA).getTime();
          const dateB = new Date(valueB).getTime();

          if (dateA < dateB) return sortDirection === "asc" ? -1 : 1;
          if (dateA > dateB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        } else {
          if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
          if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
          return 0;
        }
      });
    }

    return sortedArray;
  }, [currentPosts, sortColumn, sortDirection]);

  // Fetch ID details
  const openIdDetails = async (row) => {
    setShowIdModal(true);
    setIdLoading(true);
    try {
      setIdDetails(row || []);
    } catch (err) {
      setIdDetails([]);
    } finally {
      setIdLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid mb-2 mt-2">
        <table id="" className="table table-bordered" style={{ color: "#222" }}>
          <thead className="">
            <tr>
              <th className="width-1p text-center" scope="row">
                <input
                  type="checkbox"
                  id={`${selectId}-checkbox`}
                  checked={
                    currentPosts.length > 0 &&
                    currentPosts.every((item) => selectedIds.includes(item.id))
                  }
                  onChange={handleSelectAll}
                />
              </th>
              {/* <th onClick={() => handleSort("id")} className="width-3p text-center" scope="col">
                S.No.{" "}
                <b>
                  <BsArrowDownUp />
                </b>
              </th> */}
              {/* <th onClick={() => handleSort("id")} className="width-3p" scope="col">
                id{" "} <b> <BsArrowDownUp /> </b>
              </th> */}
              <th
                onClick={() => handleSort("id")}
                className="width-3p"
                scope="col"
              >
                refid
                <b>
                  <BsArrowDownUp />
                </b>
              </th>
              {/* <th className="width-9p text-center" scope="col">
                Source text
              </th> */}
              <th className="width-9p" scope="col">
                Clean text
              </th>
              {/* <th className="width-7p text-center" scope="col">
                Source MD5
              </th> */}
              <th className="width-7p" scope="col">
                Clean MD5
              </th>
              <th className="width-5p" scope="col">
                Current URL
              </th>
              <th
                onClick={() => handleSort("seq")}
                className="width-3p"
                scope="col"
              >
                seq{" "}
                <b>
                  <BsArrowDownUp />
                </b>
              </th>
              <th className="width-3p" scope="col">
                multipart
              </th>
              <th
                onClick={() => handleSort("part")}
                className="width-2p"
                scope="col"
              >
                part{" "}
                <b>
                  <BsArrowDownUp />
                </b>
              </th>
              {/* <th className="w-100" scope="col">
                domainname{" "}
              </th> */}
              <th
                onClick={() => handleSort("lastmodified")}
                className="width-4p"
                scope="col"
              >
                Date{" "}
                <b>
                  <BsArrowDownUp />
                </b>
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((myData, index) => (
              <tr
                key={myData.id}
                style={{
                  backgroundColor: selectedIds.includes(myData.id)
                    ? "#c1d3f0"
                    : "",
                }}
              >
                <td className="">
                  <div className="custom-control custom-checkbox text-center">
                    <input
                      id={`${selectId}-customCheck${myData.id}`}
                      type="checkbox"
                      className="custom-control-input"
                      checked={selectedIds.includes(myData.id) || selectAll}
                      onChange={() => handleCheckboxChange(myData.id)}
                    />
                  </div>
                </td>
                {/* <td className="">{myData.id}</td> */}
                <td className="">{myData.refid}</td>
                <td className="">{myData.cleantxt}</td>
                <td className="wrap-text">
                  <strong
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => openIdDetails(myData)}
                  >
                    {myData.cleanmd5}
                  </strong>
                </td>
                {myData.cur_url ? (
                  <td className="wrap-text">
                    {myData.cur_url.split("/").at(-1).length > 0
                      ? myData.cur_url.split("/").at(-1)
                      : myData.cur_url}{" "}
                  </td>
                ) : (
                  <td>NA</td>
                )}
                <td className="wrap-text">{myData.seq}</td>

                <td>
                  <EditableField
                    value={myData.multipart}
                    onChange={(value) =>
                      handleEdit(myData.id, "multipart", value)
                    }
                  />
                </td>
                <td>
                  <EditableField
                    value={myData.part}
                    onChange={(value) => handleEdit(myData.id, "part", value)}
                  />
                </td>
                <td className="">
                  <div>{formatDateString(myData.createdat)}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DetailModal
        show={showIdModal}
        title={`ID Details: ${selectedIds}`}
        data={idDetails}
        loading={idLoading}
        onClose={() => setShowIdModal(false)}
      />
    </>
  );
};

export default FetchTable;
